import { Box, Skeleton } from "@mui/material";
import React, { useState } from "react";

function Image(props) {
  const {
    onLoad: userOnLoad,
    onError: userOnError,
    style,
    width,
    height,
    sx,
    ...rest
  } = props;
  const [loaded, setLoaded] = useState(false);

  const handleLoad = (e) => {
    setLoaded(true);
    if (typeof userOnLoad === "function") userOnLoad(e);
  };

  const handleError = (e) => {
    // hide skeleton on error so caller can show placeholder if desired
    setLoaded(true);
    if (typeof userOnError === "function") userOnError(e);
  };

  // derive skeleton sizing from props/style with sensible fallback
  const derivedWidth = width || (style && style.width) || "100%";
  const derivedHeight = height || (style && style.height) || 200;

  return (
    <Box position="relative" display="inline-block" style={{ lineHeight: 0 }}>
      {!loaded && (
        <Skeleton
          variant="rectangular"
          width={derivedWidth}
          height={derivedHeight}
          animation="wave"
        />
      )}

      <Box
        component="img"
        onLoad={handleLoad}
        onError={handleError}
        style={{
          ...style,
          // keep layout while loading, fade in when ready
          opacity: loaded ? 1 : 0,
          transition: "opacity 300ms ease",
          width: width || style?.width || "100%",
          height: height || style?.height || "auto",
          display: "block",
        }}
        sx={sx}
        width={width}
        height={height}
        {...rest}
      />
    </Box>
  );
}

export default Image;
